import createTableStore from "ds/components/Table/store/useTableStore";

import {
  MODULE_PULL_REQUESTS_TABLE_COLUMNS_CONFIG,
  MODULE_PULL_REQUESTS_TABLE_STORAGE_KEY,
} from "./constants";

const useModulePullRequestsTableStore = createTableStore({
  storageKey: MODULE_PULL_REQUESTS_TABLE_STORAGE_KEY,
  config: MODULE_PULL_REQUESTS_TABLE_COLUMNS_CONFIG,
});

export default useModulePullRequestsTableStore;
